var bodyScroll = scrollTop;

function fixBody(){
    bodyScroll = $body.scrollTop();
    $body.addClass('open-resp');
    $body.css({
        'position' : 'fixed',
        'width' : '100%',
        'top': -bodyScroll,
        'overflow' : 'hidden'
    })
};

function unfixBody(){
    $body.removeClass('open-resp');
    $body.css({
        'position' : 'static',
        'top': '0',
        'overflow' : 'auto'
    })
    $body.scrollTop(bodyScroll);
}

$(function(){
	$('.js-toggle-menu').on('click', function(e){
        e.stopPropagation();

    	$(this).toggleClass('open');
    	$('.js-hidden-menu').toggleClass('open');
        
        if ($(this).is('.open')) {
            fixBody();
        } else {
            unfixBody();
        }
    });

    $('.js-open-resp-nav').on('click', function(){
    	$('.js-resp-nav').addClass('open');
    });

    $('.js-close-resp-nav').on('click', function(){
    	$('.js-resp-nav').removeClass('open');
    });

    $body.on('click', function(){
        if ($('.js-hidden-menu').is('.open')) {
            $('.js-toggle-menu').removeClass('open');
            $('.js-hidden-menu').removeClass('open');
            unfixBody();
        }
    });

    $('.js-hidden-menu').hover(function(){
        $body.addClass('no-scroll');
    }, function(){
        $body.removeClass('no-scroll');
    });

    $('.js-cat-filter').on('click', function(){
        maxWidthMd(function(){
            if ($('.js-aside').is('.open')) {
                unfixBody();
            } else {
                fixBody();
            }
            $('.js-aside').toggleClass('open');
        }, function(){});
    });
});